"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getForestTypeByKey = exports.forest_type_map = exports.forest_type_list = exports.forest_types = void 0;
const util_1 = require("./util");
exports.forest_types = [
    { key: 'douglas_fir', display_name: 'Douglas Fir', tupuake_forest_type_id: 1 },
    { key: 'exotic_hardwood', display_name: 'Exotic Hardwoods', tupuake_forest_type_id: 2 },
    { key: 'exotic_softwood', display_name: 'Exotic Softwoods', tupuake_forest_type_id: 3 },
    { key: 'indigenous', display_name: 'Indigenous', tupuake_forest_type_id: 4 },
    { key: 'radiata', display_name: 'Pinus Radiata', tupuake_forest_type_id: 6 },
    { key: 'pinus_radiata', display_name: 'Pinus Radiata', tupuake_forest_type_id: 6 },
];
exports.forest_type_list = exports.forest_types.map((data) => data.key);
exports.forest_type_map = (0, util_1.toMap)(exports.forest_types);
const getForestTypeByKey = (species) => exports.forest_type_map[species];
exports.getForestTypeByKey = getForestTypeByKey;
